import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: "/welcome",
        component: () => import('@/codes/init/index.vue'),
        children:[
            {
                path: '/welcome',
                name: 'page-welcome',
                component: () => import("@/codes/home/index.vue"),
                meta: {
                    title: '欢迎使用',
                }
            },
            {
                path: '/monitor',
                name: 'page-monitor',
                component: () => import("@/codes/home/monitor/index.vue"),
                meta: {
                    title: '运维管理',
                }
            },
            {
                path: '/404',
                name: 'page-404',
                component: () => import('@/codes/error/404.vue'),
                meta: {
                    title: '无此页',
                    id: "page-404" // 全局唯一
                }
            },
            {
                path: '/403',
                name: 'page-403',
                component: () => import('@/codes/error/403.vue'),
                meta: {
                    title: '无权限',
                    id: "page-403" // 全局唯一
                }
            },
        ]
    },
    {
        path: '/login',
        name: 'page-login',
        component: () => import("@/codes/login/index.vue"),
        meta: {
            title: '账号登录',
            id: "page-login"// 全局唯一
        }
    },
    {
        path: '/logout',
        name: 'page-logout',
        meta: {
            title: '账号登出',
            id: "page-logout"// 全局唯一
        },
        redirect: '/login'
    },
];

const router = new VueRouter({
    linkActiveClass: 'selected',
    routes
})

let addRouterFlag = true;


// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题

// push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}



// replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace= function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
}

router.beforeEach(  (to, from,next) => {
    let token = localStorage.getItem("token");

    if (to.path === "/login") {
        next();
        return
    }

    // token 不存在
    if (!token) {
        store.commit("logout",token);
        next();
        return
    }

    let userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        if (addRouterFlag) {
            const menu = JSON.parse(userInfo).menu || [];
            appendMenuRoutes(menu);
            addRouterFlag = false;
            next({ ...to, replace: true });
        } else {
            document.title = (to.meta && to.meta.title) || document.title;
            next();
        }
    } else {
        next("/login");
    }
})

/**
 * 把登录返回的菜单（含 children）注册为子路由。
 * 仅注册白名单内的组件，避免库里写了不存在的目录导致点击报错。
 */
const COMPONENT_ALIAS = {
    maintenance: "monitor",
    ops: "monitor",
    yunwei: "monitor",
};

const ALLOWED_COMPONENTS = new Set([
    "comparison",
    "filter",
    "user",
    "log",
    "monitor",
    "maintenance",
]);

function resolveComponent(comp) {
    const raw = String(comp || "").replace(/^\/+|\/+$/g, "");
    const mapped = COMPONENT_ALIAS[raw] || raw;
    if (!ALLOWED_COMPONENTS.has(raw) && !ALLOWED_COMPONENTS.has(mapped)) {
        return null;
    }
    return mapped;
}

function appendMenuRoutes(menuList) {
    const leaves = [];
    const walk = (list) => {
        (list || []).forEach((item) => {
            if (item.children && item.children.length) {
                walk(item.children);
                return;
            }
            if (item.isShow === false || item.isShow === "false") {
                return;
            }
            if (!item.component || !item.path) {
                return;
            }
            leaves.push(item);
        });
    };
    walk(menuList);

    const existed = new Set((routes[0].children || []).map((r) => r.path));
    const dynamicChildren = [];
    leaves.forEach((item) => {
        const path = item.path.startsWith("/") ? item.path : "/" + item.path;
        if (existed.has(path) || path === "/monitor") {
            return;
        }
        const comp = resolveComponent(item.component);
        if (!comp) {
            console.warn("跳过未知菜单组件:", item.title, item.component);
            return;
        }
        const route = {
            path,
            name: item.name || path.replace(/\//g, "-"),
            meta: {
                title: item.title,
            },
            component: () => import(`@/codes/home/${comp}/index`),
        };
        routes[0].children.push(route);
        dynamicChildren.push(route);
        existed.add(path);
    });
    if (dynamicChildren.length) {
        router.addRoutes([{
            path: "/",
            component: () => import("@/codes/init/index.vue"),
            children: dynamicChildren,
        }]);
    }
}

export default router
